export enum ActionsEnumDeprecate {
  um_manageUsers,
  um_userDetail_stateful,
  um_editUserDetail,
  um_createUser,
  um_securityAndPrivacy,
  n_post_stateful,
}
